module.exports = __webpack_public_path__ + "img/recruit_text.dc9cb7a2.svg";